import { useEffect, useRef } from 'react';

import { mountBuilderScene, whenDisplayFontReady } from './builderScene';

import classes from './style.module.css';

const SCENE_DESCRIPTION = 'Integrations drift loosely around a switched-off product until Ampersand comes on; '
  + 'its field pulls each one into place, connects it along the grid, and the product scales as more arrive.';

/**
 * The website's "Builder Layer" animation. Decorative, so it is labelled for
 * screen readers but takes no focus.
 */
export const BuilderGraphic = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let dispose: (() => void) | null = null;
    let cancelled = false;

    // Doto has to be measurable before the scene sizes its node pills.
    whenDisplayFontReady().then(() => {
      if (cancelled) return;
      dispose = mountBuilderScene(canvas, { reducedMotion });
    });

    return () => {
      cancelled = true;
      dispose?.();
    };
  }, []);

  return (
    <div className={classes.graphic}>
      <canvas
        ref={canvasRef}
        role="img"
        aria-label={SCENE_DESCRIPTION}
        className={classes.graphicCanvas}
      />
    </div>
  );
};
